// YANKI · motion leaf — quote reveal

import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import { DUR } from "@/features/landing/motion/tokens";

export function useYankiMotion(scope: React.RefObject<HTMLElement | null>) {
  const reduced = usePrefersReducedMotion();

  useGSAP(
    () => {
      const quote = scope.current?.querySelector<HTMLElement>(".yanki__quote");
      const attr = scope.current?.querySelector<HTMLElement>(".yanki__attr");
      const sigil = scope.current?.querySelector<HTMLElement>(".yanki__sigil");

      if (reduced) {
        gsap.set([quote, attr, sigil], { clearProps: "all" });
        return;
      }

      if (sigil) {
        gsap.fromTo(sigil, { autoAlpha: 0, scale: 0.92, rotate: -8 }, {
          autoAlpha: 1, scale: 1, rotate: 0,
          duration: DUR.slow * 1.5, ease: "expo.out",
          scrollTrigger: { trigger: sigil, start: "top 80%", toggleActions: "play none none reset" },
        });
      }

      if (quote) {
        gsap.fromTo(quote, { autoAlpha: 0, y: 24 }, {
          autoAlpha: 1, y: 0, duration: DUR.slow, ease: "power3.out",
          delay: 0.1,
          scrollTrigger: { trigger: quote, start: "top 80%", toggleActions: "play none none reset" },
        });
      }
      if (attr) {
        gsap.fromTo(attr, { autoAlpha: 0, y: 16 }, {
          autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power2.out",
          delay: 0.3,
          scrollTrigger: { trigger: attr, start: "top 88%", toggleActions: "play none none reset" },
        });
      }
    },
    { scope, dependencies: [reduced] }
  );
}